import React from 'react';
import { Box, Typography, List, ListItemButton, Chip } from '@mui/material';
import { LocalOffer } from '@mui/icons-material';

const DiscountList = ({ discounts = [], selectedId, onSelect, emptyText }) => {
  if (discounts.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 5, px: 2 }}>
        <LocalOffer sx={{ fontSize: 36, color: '#CBD5E1', mb: 1 }} />
        <Typography sx={{ fontSize: '0.85rem', color: '#94A3B8', fontWeight: 600 }}>
          {emptyText || 'No discounts available'}
        </Typography>
        <Typography sx={{ fontSize: '0.72rem', color: '#CBD5E1', mt: 0.5 }}>
          Contact your store manager to set up discounts
        </Typography>
      </Box>
    );
  }

  return (
    <List disablePadding>
      {discounts.map((d) => {
        const isSelected = d.id === selectedId;
        const valueLabel = d.discount_type === 'percentage' ? `${d.discount_value}%` : `₹${d.discount_value}`;
        const minLabel   = d.minimum_bill_value ? `Min ₹${d.minimum_bill_value}` : 'No minimum';

        return (
          <ListItemButton
            key={d.id}
            onClick={() => onSelect(d)}
            sx={{
              py: { xs: 1.25, md: 1 }, px: 2,
              borderLeft: isSelected ? '3px solid #4F46E5' : '3px solid transparent',
              bgcolor: isSelected ? '#EEF2FF' : 'transparent',
              borderBottom: '1px solid #F1F5F9',
              '&:hover': { bgcolor: isSelected ? '#EEF2FF' : '#F8FAFC' },
            }}
          >
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Typography sx={{
                fontSize: { xs: '0.88rem', md: '0.82rem' },
                fontWeight: 700,
                color: isSelected ? '#4F46E5' : '#1E293B',
                lineHeight: 1.3,
              }}>
                {d.name}
              </Typography>
              <Typography sx={{ fontSize: '0.72rem', color: '#94A3B8', mt: 0.2 }}>
                {d.discount_type === 'percentage' ? 'Percentage' : 'Flat'} · {valueLabel} · {minLabel}
              </Typography>
              {d.product_bucket_ids?.length > 0 && (
                <Chip
                  label="Bucket restricted"
                  size="small"
                  sx={{ mt: 0.5, height: 16, fontSize: '0.58rem', fontWeight: 700, bgcolor: '#FFFBEB', color: '#D97706' }}
                />
              )}
            </Box>
            {isSelected && (
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#4F46E5', flexShrink: 0, ml: 1 }} />
            )}
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default DiscountList;
